import React from 'react';
import Modal from 'react-modal';
import {connect} from "react-redux";
import PropTypes from 'prop-types';

import {NotificationManager} from "react-notifications";

import * as RaceActions from "../../../../actions/race"
import UserFieldDataType from "../../../../utils/enums/UserFieldDataTypeEnum";
import UserFieldElement from '../../../reusable/UserFieldElement';
import config from "../../../../../../server/src/config";
import moment from "moment";
import {getRegi} from "../../../../../../common/src/util/lib";
import {confirm} from "../../../../utils/confirmDialog";
import {alert} from "../../../../utils/alertDialog";

class ExportSignupsAndResultsDialog extends React.Component {

    static propTypes = {
        exportType: PropTypes.string.isRequired,
        onClose: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            week: moment(new Date()).add(props.exportType === 'signup' ? 0 : -3, 'days').isoWeek().toString(),
            raceType: null,
            longRaceStatus: null
        }
    }

    fields = [];
    render() {
        const isRaces = this.props.race.races.filter(race => race.Uge === Number(this.state.week) && race.AntalDuer > 0).size > 0;
        const raceTypeEnabled = this.props.exportType === 'result' && this.props.race.races.filter(race => race.Uge === Number(this.state.week) && race.LMU === 'O' && race.AntalDuer > 0 && (race.Sektion !== null || getRegi(race.Farvekode) === 'DdB')).size > 0;
        const longRacesIncluded = raceTypeEnabled && this.state.raceType === 'country' || raceTypeEnabled && this.state.raceType === 'all';
        return <div>
            <Modal
                isOpen={true}
                onRequestClose={() => {
                    this.props.onClose()
                }}
                style={{
                    overlay: {
                        zIndex: 10,
                    },
                    content: {
                        height: '375px',
                        width: '350px',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                    }
                }}
            >
                <div className="dialog">
                    <div className="dialog-title">Overfør {this.props.exportType === 'signup' ? 'anmeldelser' : 'resultater'}</div>

                    <div className="dialog-body">
                        <div className="dialog-inner-body">
                            <table className="fields">
                                <tbody>
                                <tr>
                                    <td><label htmlFor="week">Uge</label></td>
                                    <td>
                                        <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field50" containerClassName="display-inline-block"
                                                          name="week" id="week" maxLength="2" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY, value: "[0-9]{1,2}"}]} value={this.state.week}
                                                          autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                          onChange={(e) => {
                                                              this.onStandardFieldChange(e);
                                                              this.setState({raceType: null, longRaceStatus: null});
                                                          }}
                                                          ref={instance => { this.fields[0] = instance; }}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={2}>
                                        <UserFieldElement dataType={UserFieldDataType.options} className="field-option-lines large-vertical-spacing"
                                                          name="raceType" id="raceType" options={[
                                                              {key: 'all', value: 'Alle flyvninger', disabled: !raceTypeEnabled},
                                                              {key: 'nonCountry', value: 'Uden landsflyvninger', disabled: !raceTypeEnabled},
                                                              {key: 'country', value: 'Kun landsflyvninger', disabled: !raceTypeEnabled},
                                                          ]} value={this.state.raceType}
                                                          autoCheckErrors={true} required={raceTypeEnabled} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                          onChange={(e) => {
                                                              this.onStandardFieldChange(e);
                                                              if (e.target.value === 'nonCountry') this.setState({longRaceStatus: null});
                                                          }}
                                                          ref={instance => { this.fields[1] = instance; }}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={2}>
                                        <UserFieldElement dataType={UserFieldDataType.options} className="field-option-lines small-vertical-spacing"
                                                          name="longRaceStatus" id="longRaceStatus" options={[
                                                              {key: 'finished', value: 'Landsflyvninger færdigberegnede', disabled: !longRacesIncluded},
                                                              {key: 'not-finished', value: 'Landsflyvninger IKKE færdigberegnede', disabled: !longRacesIncluded},
                                                          ]} value={this.state.longRaceStatus}
                                                          autoCheckErrors={true} required={longRacesIncluded} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                          onChange={this.onStandardFieldChange}
                                                          ref={instance => { this.fields[2] = instance; }}
                                        />
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="actions-row">
                        <button className="btn-primary" name="send" onClick={() => {this.onSend()}}>Send</button>
                        <button className="btn-secondary float-right" onClick={() => {this.props.onClose()}}>Annuller</button>
                    </div>
                </div>
            </Modal>
        </div>
    }

    onSend = () => {
        if (this.allInputValid()) {
            let letsGo = true;
            if (this.props.race.races.filter(race => race.Uge === Number(this.state.week) && race.AntalDuer > 0 && (race.Sektion !== null || getRegi(race.Farvekode) === 'DdB') && (
                (this.state.raceType === 'country' && race.LMU === 'O') ||
                (this.state.raceType === 'nonCountry' && race.LMU !== 'O') ||
                (this.state.raceType !== 'country' && this.state.raceType !== 'nonCountry')
            )).size === 0) confirm("Ingen duer", <span>Der optræder ingen duer i udlæsningen. Ønsker du alligevel at sende data?</span>, () => {}, () => {letsGo = false;});
            if (letsGo) {
                this.props.dispatch(RaceActions.sendFromClub(this.props.exportType, {
                    week: this.state.week,
                    raceType: this.state.raceType === null ? 'default' : this.state.raceType,
                    longRaceStatus: this.state.longRaceStatus
                }, (response) => {
                    if (response !== '') {
                        const msg = [this.props.exportType === 'signup' ? 'Anmeldelser' : 'Resultater', ' for uge ', this.state.week, ' er sendt.', <br/>, <br/>, <b>Følgende meddelelser er modtaget:</b>, <br/>].concat(response.split('|').map((line, ix) => [line, <br/>]));
                        alert("Info", msg, () => {}, {textAlign: "left"});
                    } else NotificationManager.success((this.props.exportType === 'signup' ? 'Anmeldelser' : 'Resultater') + ' for uge ' + this.state.week, ' er sendt.', "Info", 4000);
                    this.props.onClose();
                }));
            }
        } else {
            this.fields.forEach((field) => {
                field.setState({visited: true});
            });
        }
    };

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };

    allInputValid = () => {
        let result = true;
        this.fields.forEach((field, ix) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };
}

const mapStateToProps = (state) => ({
    auth: {
        currentEntity: state.auth.currentEntity,
    },
    race: {
        races: state.race.races
    }
});

export default connect(mapStateToProps)(ExportSignupsAndResultsDialog);


// WEBPACK FOOTER //
// ./src/client/src/components/pages/home/dialogs/ExportSignupsAndResultsDialog.js